module.exports = __webpack_public_path__ + "img/logo-qichezhidao.6a6a4c4e.png";